// Todo el contenido editable de la boda vive aquí.
export const wedding = {
  bride: "Carolina",
  groom: "Roberto",
  monogram: "C & R",
  tagline: "Te elijo hoy y para siempre.",
  // Fecha objetivo (hora local del evento)
  date: "2027-02-13T17:00:00",
  dateLabel: "13 de Febrero, 2027",
  dateShort: "13.02.2027",
  hashtag: "#CarolinaYRoberto2027",

  venue: {
    name: "Hacienda de los Morales",
    line1: "Ceremonia & Recepción",
    ceremonyTime: "5:30 pm",
    receptionTime: "7:00 pm",
    address: "Vázquez de Mella 525, Polanco, Ciudad de México",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Hacienda+de+los+Morales+Ciudad+de+Mexico",
    note: "Estacionamiento y valet disponibles en el lugar.",
  },

  // Pon en true cuando ya tengan el itinerario para mostrarlo de nuevo.
  showItinerary: false,
  itinerary: [
    { time: "17:00", title: "Ceremonia", detail: "Recíbenos puntualmente." },
    { time: "18:30", title: "Cóctel", detail: "Bienvenida y brindis al aire libre." },
    { time: "20:00", title: "Cena", detail: "Banquete de tres tiempos." },
    { time: "22:00", title: "Fiesta", detail: "Baile hasta el amanecer." },
  ],

  dressCode: {
    label: "Etiqueta Rigurosa",
    sub: "Black Tie",
    detail:
      "Ellos: esmoquin o traje oscuro. Ellas: vestido largo. El blanco queda reservado para la novia.",
    images: [
      "https://images.unsplash.com/photo-1785651523631-6913d52822bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
      "https://images.unsplash.com/photo-1593030761757-71fae45fa0e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    ],
  },

  gifts: {
    intro:
      "Tu presencia es nuestro mejor regalo. Si deseas obsequiarnos algo, aquí algunas opciones.",
    bank: {
      bankName: "BBVA México",
      holder: "Carolina & Roberto",
      clabe: "012 180 0011 2233 4455",
      clabeLabel: "CLABE · Transferencias",
    },
    accounts: [],
    registries: [
      { store: "Liverpool", url: "https://mesaderegalos.liverpool.com.mx", code: "No. 51234567" },
      { store: "Amazon", url: "https://www.amazon.com.mx/wedding", code: "Lista Carolina & Roberto" },
    ],
  },

  notes: [
    { title: "Niños", text: "Amamos a los pequeños, pero será una celebración solo para adultos." },
    { title: "Confirmación", text: "Agradecemos tu confirmación antes del 13 de enero de 2027." },
    { title: "Clima", text: "Habrá momentos al aire libre; trae algo abrigador para la noche." },
  ],

  hotel: {
    name: "Hotel Boutique Casa Mérida",
    description:
      "Reservamos una tarifa preferencial para nuestros invitados en este hotel, a pocos minutos del lugar de la celebración.",
    address: "Calle 60, Centro Histórico, Mérida, Yucatán",
    note: 'Menciona el código "BODA C&R" al reservar para la tarifa especial.',
    bookingUrl: "https://www.booking.com",
    image:
      "https://images.unsplash.com/photo-1698854576937-3ce8f5c00a7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },

  gallery: [
    "https://images.unsplash.com/photo-1782786399294-f4af1c967b9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1783816297232-3f66049496ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1776266099566-676119a0f06e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1782786400148-e8d57fd1ab1b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1724280120520-c52b4c1170fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1665960213508-48f07086d49c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1630526720753-aa4e71acf67d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    "https://images.unsplash.com/photo-1715285977619-6d9357168f46?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ],

  locationImage:
    "https://images.unsplash.com/photo-1661629906152-8409094b70ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",

  media: {
    heroVideo: "/media/hero.mp4",
    heroPoster: "/media/hero-poster.jpg",
    // Miniatura del botón "Ver Save the Date".
    saveTheDateThumb: "/media/hero-poster.jpg",
    // Save the Date: se abre en un lightbox con el player de YouTube (unlisted funciona perfecto).
    // Pega SOLO el ID del video: youtube.com/watch?v=XXXXXXXXXXX  ->  "XXXXXXXXXXX"
    // (o youtu.be/XXXXXXXXXXX)
    saveTheDateYouTubeId: "1WSzfGahExE",
  },
};
